import i18n from '@/services/i18n'
import {
  ApprovalFlowTypeEnum,
  PolicyActTypeEnum,
  PolicyConditionTypeEnum,
  PolicyFromTypeEnum,
  PolicyItemModel,
  PolicyToTypeEnum,
  PolicyTypeMap,
} from '@/constants/enum'
import { LogItemModel, PageModel } from '@/services/apis/setting/module'
import { getconditionText } from '@/utils/setting'
export const transLogData = (listPage: PageModel<LogItemModel>): PageModel<LogItemModel> => {
  return {
    ...listPage,
    content: listPage.content.map(v => {
      v.otherDetail = v.otherDetail || {}
      v.eventDetail = v.eventDetail || {}
      if (
        !(
          v.otherDetail[i18n.t('log.detail') as string] ||
          v.otherDetail[i18n.t('log.before') as string] ||
          v.otherDetail[i18n.t('log.after') as string]
        )
      ) {
        return v
      }

      if (v.subjectType === i18n.t('log.teamPolicy')) {
        return {
          ...v,
          otherDetail: Object.keys(v.otherDetail).reduce((result: any, curr: any) => {
            result[curr] = transPolicy(v.otherDetail[curr])
            return result
          }, {}),
        }
      }
      return v
    }),
  }
}
const transPolicy = (data: PolicyItemModel) => {
  if (data.conditionType === PolicyConditionTypeEnum.VALUE_GREATER && data.type === (3 as any)) {
    return {
      [i18n.t('policy.type') as string]: PolicyTypeMap[data.type!],
      [i18n.t('policy.transfer') as string]: getPolicyInitiator(data),
      From: getPolicyFrom(data),
      To: getPolicyTo(data),
      [i18n.t('policy.action') as string]:
        data.act === PolicyActTypeEnum.ALLOW
          ? i18n.t('policy.actionRule')
          : i18n.t('policy.actionNone'),
      [i18n.t('policy.priority') as string]: data.priority,
      [i18n.t('record.approval') as string]: getAuditUserRule(data),
    }
  } else {
    return {
      [i18n.t('policy.type') as string]: PolicyTypeMap[data.type!],
      [i18n.t('policy.condition') as string]: getconditionText(data),
      [i18n.t('policy.transfer') as string]: getPolicyInitiator(data),
      From: getPolicyFrom(data),
      To: getPolicyTo(data),
      [i18n.t('policy.action') as string]:
        data.act === PolicyActTypeEnum.ALLOW
          ? i18n.t('policy.actionRule')
          : i18n.t('policy.actionNone'),
      [i18n.t('policy.priority') as string]: data.priority,
      [i18n.t('record.approval') as string]: getAuditUserRule(data),
    }
  }
}
// 获取发起人
const getPolicyInitiator = (data: PolicyItemModel) => {
  if (data.initiatorIsAny) {
    return i18n.t('policy.allUser')
  }
  return `${data.initiatorUserDtoList?.map(v => v.userName)}`
}
// 获取From
const getPolicyFrom = (data: PolicyItemModel) => {
  if (data.fromType === PolicyFromTypeEnum.ANY) {
    return i18n.t('policy.any')
  }
  if (data.fromAccountIsAny === 1) {
    return i18n.t('policy.allWallet')
  }
  return `${data.fromAccountDtoList?.map(v => v.fromAccountName)}`
}
// 获取To
const getPolicyTo = (data: PolicyItemModel) => {
  if (data.type === (3 as any)) {
    return data.toAddressList?.join(' , ')
  }
  if (data.toType === PolicyToTypeEnum.ANY) {
    return i18n.t('policy.any')
  }
  if (data.toType === PolicyToTypeEnum.UNKNOWN) {
    return i18n.t('policy.unknown')
  }
  if (data.toType === PolicyToTypeEnum.VAULT) {
    if (data.toAccountIsAny === 1) {
      return i18n.t('policy.allWallet')
    }
    return `${data.toAccountDtoList?.map(v => v.toAccountName)}`
  }
  if (data.toAccountIsAny === 1) {
    return i18n.t('policy.allWhite')
  }
  if (data.toAccountDtoList) {
    return `${data.toAccountDtoList?.map(v => v.toAccountName)}`
  }
}
// 审批流
const getAuditUserRule = (data: PolicyItemModel) => {
  if (!data.auditUserRuleDto) return null
  return data.auditUserRuleDto.reduce((curr, prev, index) => {
    if (prev.type === ApprovalFlowTypeEnum.RULE) {
      curr += `${prev.name}(${prev.num}/${prev.userDtoList?.length}): ${prev.userDtoList?.map(
        v => v.userName
      )};`
    } else {
      curr += index === 0 ? `${i18n.t('common.quickAudit')};` : `${i18n.t('common.InitiatorSelf')};`
    }

    return curr
  }, '')
}
